import type { ComponentPropsWithRef, ReactNode } from 'react'
import { useId } from 'react'

export interface CustomRadioInputProps extends Omit<
    ComponentPropsWithRef<'input'>,
    'type' | 'checked'
> {
    value?: string
    defaultChecked?: boolean
    children?: ReactNode
}

export function CustomRadioInput({
    id,
    value,
    children,
    className = '',
    defaultChecked,
    ...inputProps
}: CustomRadioInputProps) {
    const generatedId = useId()
    const inputId = id ?? generatedId

    return (
        <div>
            <input
                {...inputProps}
                id={inputId}
                type="radio"
                value={value}
                defaultChecked={defaultChecked}
                className={`sr-only peer ${className}`.trim()}
            />
            <label
                htmlFor={inputId}
                className="cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-60 block p-4 border rounded-xl peer-checked:border-primary peer-checked:ring-2 peer-checked:ring-primary peer-checked:bg-primary-shade-ligth peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2 hover:border-gray-400 transition-all"
            >
                {children}
            </label>
        </div>
    )
}
